export default __webpack_public_path__ + "images/78a8ee4a8d5bd7ce28d656d0d40aec3e-game.jpg";